import { FieldsEnum } from 'app/shared/enums';
import { MoreFiltersTypeEnum } from 'app/shared/enums/FiltersOptions.enum';
import { OfferFiltersInterface } from 'app/shared/interfaces/OfferFilters.interface';

type OfferFiltersDtoField = keyof OfferFiltersInterface;

const formFieldToDtoField: Record<string, OfferFiltersDtoField> = {
  [MoreFiltersTypeEnum.ExcessType]: 'excessType',
  [MoreFiltersTypeEnum.Amortization]: 'amortizationType',
  [MoreFiltersTypeEnum.FormOfRepair]: 'acRepairType',
  [MoreFiltersTypeEnum.AssistanceAfterFailure]: 'afterFailure',
  [MoreFiltersTypeEnum.SubstituteCar]: 'substituteCar',
  [FieldsEnum.Sort]: 'sorting',
};

export const dtoFieldToFormField: Record<
  OfferFiltersDtoField,
  string
> = Object.entries(formFieldToDtoField).reduce(
  (acc, [formField, dtoField]) => ({ ...acc, [dtoField]: formField }),
  {} as Record<OfferFiltersDtoField, string>
);
